import { GetSocialTemplateRequest } from "../../../../cores/openAi/interface/api/get-social-templates";

interface BuildOpenAiPostRequestParams {
  industry: string;
  subject: string;
  additionalInfo: string;
  noEmoticons: boolean;
  noHashtags: boolean;
  socialMedias: string[];
  contentRules?: {
    noEmojis: string;
    noHashtags: string;
  };
}

export function buildOpenAiPostRequest(
  params: BuildOpenAiPostRequestParams
): GetSocialTemplateRequest {
  const rules: string[] = [];

  if (params.noEmoticons) {
    rules.push(
      params.contentRules?.noEmojis ??
        "No incluyas emojis ni emoticones en el texto generado."
    );
  }

  if (params.noHashtags) {
    rules.push(
      params.contentRules?.noHashtags ??
        "No incluyas hashtags en el texto generado."
    );
  }

  let additionalInfo = params.additionalInfo.trim();

  if (rules.length) {
    additionalInfo = additionalInfo
      ? `${additionalInfo}\n\n${rules.join(" ")}`
      : rules.join(" ");
  }

  return {
    industry: params.industry.trim(),
    subject: params.subject.trim(),
    additionalInfo,
    emoticons: !params.noEmoticons,
    hashtags: !params.noHashtags,
    socialMedias: params.socialMedias,
  };
}
